import ITextProps from '../ITextProps';

import { FontWeight } from 'shared/enums';

import c from './textXS.module.scss';

const TextXS = ({ children, className, color, text, textAlign, fontWeight, noWrap }: ITextProps) => {
  return (
    <div
      className={`${className || ''} ${c.textXs}`}
      style={{
        textAlign: textAlign || 'initial',
        fontWeight: fontWeight || FontWeight.Light,
        color: `var(${color})`,
        whiteSpace: noWrap ? 'nowrap' : undefined,
      }}>
      {text || children}
    </div>
  );
};

export default TextXS;
